"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineWarnings = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineConfigWarnings_1 = require("./getOrderLineConfigWarnings");
const getOrderLineWarnings = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    return (0, getOrderLineConfigWarnings_1.getOrderLineConfigWarnings)(latest_version.config, item.type);
};
exports.getOrderLineWarnings = getOrderLineWarnings;
